export default __webpack_public_path__ + "static/media/hht2_ep02_book_wp_01.328af9af.jpg";